import { useCachedResource } from "common-fe";
import { useScoreApi, unwrap } from "../api/scoreApi";
import { useScoreContext } from "../context/ScoreContext";
import { judges } from "../local/db";

/**
 * A show's score-judge roster (GET /judge, card #730's JUDGE table).
 * Cache-first (#421 pattern), like useClassesForShow: served from the
 * IndexedDB `judges` store, revalidated from score-api when online.
 *
 * card #761 — section-judge gating needs this to resolve "which score-judge
 * roster id sits at arena position C for this class" (Class.judgeAssignments
 * stores a NAME per position; Class.sectionJudgeAssignments stores a
 * score-judge roster ID per section, #759) — see
 * ../util/sectionJudgeGating.js for the name-matching resolver that
 * consumes this list.
 */
export function useShowJudges(showId) {
  const api = useScoreApi();
  const { online } = useScoreContext();
  return useCachedResource(
    async () => {
      if (!showId) return [];
      const cached = await judges.byShow(showId);
      if (!cached.length) return undefined;
      return cached;
    },
    async () => {
      if (!showId) return [];
      const all = unwrap(await api.judges.listJudges(showId));
      await judges.putAll(all);
      return all;
    },
    [api, showId],
    online,
  );
}
